const Dashboard = () => import("./dashboard/views/Dashboard.vue");
import LoanRoutes from "./loan/routes";
import ReportRoutes from "./report/routes";
import PayslipRoutes from "./payslip/routes";

export default [
  {
    path: "dashboard",
    component: Dashboard,
  },
  {
    path: "loan",
    redirect: "/ess/payroll/loan/view-all",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    children: LoanRoutes,
  },
  {
    path: "payslip",
    redirect: "/ess/payroll/payslip/view-all",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    children: PayslipRoutes,
  },
  {
    path: "report",
    redirect: "/ess/payroll/report/generate",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    children: ReportRoutes,
  },
];
